import { render, staticRenderFns } from "./GlossSearchBar.vue?vue&type=template&id=6f2fae72&"
import script from "./GlossSearchBar.vue?vue&type=script&lang=ts&"
export * from "./GlossSearchBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports